<template>
    <div class="top-comments-report" :class="{ fullscreen: fullScreen }">
        <div class="title" v-if="fullScreen">
            <ChartDoddleIcon />
            <h2>Top Best/Worst Comments</h2>
        </div>
        <div class="toolbar">
            <div class="left">
                <div class="buttons">
                    <IconButton :onClick="exportToExcel" v-tippy="{ content: $t('report.download') }">
                        <md-icon>download</md-icon>
                    </IconButton>
                    <IconButton :onClick="switchToFullScreenMode" v-tippy="{ content: $t('report.fullScreen') }">
                        <md-icon v-if="!fullScreen">fullscreen</md-icon>
                        <md-icon v-else>fullscreen_exit</md-icon>
                    </IconButton>
                </div>
            </div>
        </div>

        <div class="tables">
            <div class="table-wrapper table-top-best-comments">
                <div class="table-title">
                    <i class="material-icons text-success">sentiment_very_satisfied</i>
                    <h3>{{ $t('report.topBestComments') }}</h3>
                </div>
                <ve-table
                    :columns="getColumns()"
                    :table-data="data.topBestComments"
                    :row-style-option="rowStyleOption"
                    :border-x="true"
                    :border-y="true"
                    row-key-field-name="_id"
                    id="comments-table"
                    :fixed-header="true"
                />
            </div>
            <div class="table-wrapper table-top-worst-comments">
                <div class="table-title">
                    <i class="material-icons text-danger">sentiment_very_dissatisfied</i>
                    <h3>{{ $t('report.topWorstComments') }}</h3>
                </div>

                <ve-table
                    :columns="getColumns()"
                    :table-data="data.topWorstComments"
                    :row-style-option="rowStyleOption"
                    :border-x="true"
                    :border-y="true"
                    row-key-field-name="_id"
                    id="comments-table"
                    :fixed-header="true"
                />
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import _ from "lodash";
import IconButton from "../../Pages/Settings/components/IconButton.vue";
import { expertToExcel } from "../../../utils/utils";
import { REPORT_API } from "../../../api/statistics";
import log2 from "../../../utils/log2";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import fscreen from "fscreen";

import enUS from "vue-easytable/libs/locale/lang/en-US.js";
import { VePagination } from "vue-easytable";
import { VeLocale } from "vue-easytable";

Vue.use(VePagination);
VeLocale.use(enUS);
import AntRate from "ant-design-vue/lib/rate";

const log = log2("TopComments");
export default Vue.extend({
    name: "TopComments",
    components: { ChartDoddleIcon, IconButton },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            loadingInstance: null,
            data: {
                topBestComments: [],
                topWorstComments: [],
            },
            fullScreen: false,
            cancels: [],
            rowStyleOption: {
                stripe: true,
            },
        };
    },
    methods: {
        getColumns() {
            console.log("getColumns");
            return [
                {
                    field: "author",
                    key: "author",
                    title: this.$t('report.author'),
                    align: "left",

                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <span>{row.visitor.fullname}</span>;
                    },
                },
                {
                    field: "point",
                    key: "point",
                    title: this.$t('message.point'),
                    align: "left",
                    width: 200,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return h(AntRate, {
                            props: {
                                value: row.point,
                                disabled: true,
                            },
                        });
                    },
                },
                {
                    field: "comment",
                    key: "comment",
                    title: this.$t('message.comment'),
                    align: "left",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return <p>{row.description}</p>;
                    },
                },
            ];
        },
        switchToFullScreenMode() {
            if (this.fullScreen) {
                this.closeFullScreenMode();
            } else {
                const elem = document.querySelector(".top-comments-report");
                fscreen.requestFullscreen(elem);
                this.fullScreen = true;
            }
        },
        closeFullScreenMode() {
            fscreen.exitFullscreen();
        },
        fetch() {
            this.loading = true;
            this.loadingInstance.show();
            const p1 = REPORT_API.topBestComments(this.filters).then((res) => {
                log("topBestComments data fetched", res);
                this.data.topBestComments = res;
            });
            const p2 = REPORT_API.topWorstComments(this.filters).then((res) => {
                log("topWorstComments data fetched", res);
                this.data.topWorstComments = res;
            });
            Promise.all([p1, p2])
                .then(() => {
                    this.loading = false;
                    this.loadingInstance.close();
                })
                .catch((err) => {
                    this.loading = false;
                    this.loadingInstance.close();
                    console.error(err);
                });
        },
        exportToExcel() {
            const { buckets, timeSeriesType } = this.data;
            log("exportToExcel.buckets", buckets);
            const data = buckets.map((bucket) => {
                const avgAgentWaitTime = bucket.avgAgentWaitTime;
                const date = {
                    hour: moment(bucket.date).format("DD/MM/YYYY HH:mm"),
                    day: moment(bucket.date).format("DD/MM/YYYY"),
                    month: moment(bucket.date).format("MM/YYYY"),
                    week: moment(bucket.date).format("YYYY-WW[week]"),
                }[timeSeriesType];
                return {
                    date,
                    avgAgentWaitTime,
                };
            });
            const excelData = [...data];
            expertToExcel(excelData, `agent_wait_time_timeseries.xlsx`, "Sheet 1");
        },
    },
    created() {
        const fullscreenCallback = () => {
            console.log("fullscreenCallback", fscreen.fullscreenElement);
            if (fscreen.fullscreenElement !== null) {
                this.fullScreen = true;
            } else {
                this.fullScreen = false;
            }
            this.$forceUpdate();
        };
        fscreen.addEventListener("fullscreenchange", fullscreenCallback);
        this.cancels.push(() => {
            fscreen.removeEventListener("fullscreenchange", fullscreenCallback);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".top-comments-report"),
            name: "wave",
        });
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
        data: {
            handler: function (val, oldVal) {},
            deep: true,
        },
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
    },
});
</script>
<style lang="scss">
.top-comments-report {
    .title {
        display: flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        margin: 0;

        h2 {
            text-align: center;
            font-weight: 700;
            font-size: 40px;
            margin: 0 !important;
        }
    }

    &.fullscreen {
        background-color: #fff;
        padding: 20px;
        overflow-y: scroll;

        .stacked-area-chart {
            height: calc(100vh - 200px);
        }
    }

    .tables {
        display: flex;
        gap: 10px;
        justify-content: space-between;

        .table-top-best-comments {
            padding-right: 10px;
            border-right: 1px solid var(--color-border-default);

            .ve-table {
                .ant-rate-star {
                    color: #28a745 !important;
                }
            }
        }

        .table-top-worst-comments {
            .ve-table {
                .ant-rate-star {
                    color: #dc3545 !important;
                }
            }
        }

        .table-wrapper {
            width: 100%;
            display: flex;
            flex-direction: column;

            .table-title {
                display: flex;
                gap: 4px;
                align-items: center;
                justify-content: center;
                margin: 0;

                h3 {
                    text-align: center;
                    font-weight: 600;
                    font-size: 25px;
                    margin: 0 !important;
                }
            }
        }
    }
}
</style>
<style scoped lang="scss">
.top-comments-report {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .toolbar {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;

            .buttons {
                display: flex;
                border: 1px solid var(--color-border-default);

                .icon-button {
                    padding: 5px;
                    width: 40px;
                    height: 34px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid var(--color-border-default);
                    border-radius: unset !important;

                    &.selected {
                        background-color: var(--color-bg-info-low-hover);

                        i {
                            color: rgb(55, 162, 255);
                        }
                    }

                    &:hover {
                        background-color: var(--color-bg-neutral-pressed);
                    }
                }

                .icon-button:last-child {
                    border-right: none;
                }
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>
